import { Observable, of, throwError } from 'rxjs';
import {
  ResponseModel,
  UserImageResponseModel,
  UserService as ApiUserService
} from '../../../api/index';
import { TransportModel } from '../../../api/model/transportModel';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { FormService } from '../../../services/index';
import { TransportForm } from '../../interfaces/renter-form/transport-form';
import { BaseService } from '@core/components/services/renter-form/base.service';
import { merge } from 'rxjs/internal/observable/merge';
import { Injectable } from '@angular/core';
import { ValidateError } from '@core/errors/validate.error';
import { UserModel } from '@core/api/model/userModel';

@Injectable({
  providedIn: 'root'
})
export class TransportService extends BaseService implements TransportForm {

  transportId: number;

  transport: FormGroup;
  images: FormGroup;

  protected constructor(
    protected formBuilder: FormBuilder,
    protected formService: FormService,
    protected apiUserService: ApiUserService,
  ) {
    super(formService);
  }

  markFormGroupTouched() {
    this.formService.markFormGroupTouched(this.transport);
    this.formService.markFormGroupTouched(this.images);
  }

  buildForm(data: TransportModel = null, images: UserImageResponseModel[] = []) {
    if (data && data.id) {
      this.transportId = data.id;
    }

    this.transport = this.formBuilder.group({
      brand: [data && data.brand, [Validators.required]],
      model: [data && data.model, [Validators.required]],
      number: [data && data.number, [Validators.required]],
      state_number: [data && data.state_number, [Validators.required]]
    });

    this.images = this.formBuilder.group({
      transport_passport_front: [null]
    });
  }

  setValues(data: TransportModel) {
    this.transport.patchValue(data);
  }

  resetForm() {
    this.transport.reset();
    this.images.reset()
  }

  requestCreateUserTransport(userId: number): Observable<ResponseModel<TransportModel>> {
    if (this.transport.invalid || this.images.invalid) {
      return throwError(new ValidateError('Error transport validation'));
    }

    return this.apiUserService.userIdTransportPost(userId, this.transport.value)
      .pipe(this.catchErrorFactory<ResponseModel<TransportModel>>(this.transport));
  }

  requestUpdateUserTransport(userId: number, transportId: number): Observable<ResponseModel<TransportModel>> {
    if (this.transport.invalid) {
      return throwError(new ValidateError('Error transport validation'));
    }

    return this.apiUserService.userIdTransportPut(userId, transportId, this.transport.value)
      .pipe(this.catchErrorFactory<ResponseModel<TransportModel>>(this.transport));
  }

  requestDeleteUserTransport(userId: number, transportId: number): Observable<ResponseModel<null>> {
    return this.apiUserService.userIdTransportDelete(userId, transportId)
      .pipe(this.catchErrorFactory<ResponseModel<null>>(this.transport));
  }

  requestUploadTransportImage(userId: number, transportId: number) {
    return this.imagesUploadFactory(this.images, (type: any) => {
      return this.apiUserService.userIdTransportIdImagePost(userId, transportId, {
        type,
        image: this.images.value[type]
      })
    });
  }
}
